import useDeepMemo from './useDeepMemo'

export default useDeepMemo
